import React from 'react'
import {useTranslation} from '@modifi/plugin-i18n'
import {
  useInputIsVisible,
  SelectComponent,
  FormInputWrapper,
  TRADE_PARTNER_STATE,
  TRADE_PARTNER_COUNTRY_CODE,
} from '@modifi/plugin-onboarding'
import {useInputValue} from '@modifi/plugin-forms'

import {withStatesOptions} from '../../hoc'
import {WithStatesOptionsProps} from '../../hoc/withStatesOptions/with-states-options'

type StateProps = WithStatesOptionsProps

const State: React.FC<StateProps> = ({options = [], ...props}) => {
  const name = TRADE_PARTNER_STATE
  const {t} = useTranslation('plugin-forms')
  const isVisible = useInputIsVisible(name)

  if (!name || !isVisible) {
    return null
  }

  return (
    <FormInputWrapper
      t={t}
      name={name}
      inputComponent={SelectComponent}
      required
      inputProps={{required: true}}
      options={options}
      {...props}
    />
  )
}

const CustomState = withStatesOptions(State)

const StateWithCountries: React.FC<StateProps> = props => {
  const {value: countryCode} = useInputValue({name: TRADE_PARTNER_COUNTRY_CODE})
  return <CustomState countryCode={typeof countryCode === 'string' ? countryCode : ''} {...props} />
}

export default StateWithCountries
